import { CastorMapper } from './mapper';

export class SearchQueryParamsMapper implements CastorMapper<Record<string, any>> {
  map(o: Record<string, any>): { [p: string]: any } {
    if (!o) return {};

    const params = {};

    for (const k of Object.keys(o)) {
      params[k] = o[k];
    }

    if ('asterLeft' in params) {
      params['asterL'] = params['asterLeft'];
      delete params['asterLeft'];
    }

    if ('asterRight' in params) {
      params['aster'] = params['asterRight'];
      delete params['asterRight'];
    }

    return params;
  }
}
